module.exports = __webpack_public_path__ + "static/empty-state-value-props-paragraph-do-75f8bc9a60a17dbb6f9c64d12251daa6.png";